module.exports = __webpack_public_path__ + "static/img/seleccion-1.7037630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/seleccion-1.jpg
// module id = bxyB
// module chunks = 1